import { Component } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MasterMakeService } from 'src/app/share/services/master-make/master-make.service';

@Component({
    selector: 'app-vehicle-make',
    templateUrl: './vehicle-make.component.html',
    styleUrls: ['./vehicle-make.component.scss'],
    standalone: false
})
export class VehicleMakeComponent {
  addVehicleMakeForm: FormGroup;
  responseMsg: string;

  constructor(
    private readonly formBuilder: FormBuilder,
    private readonly masterMakeService: MasterMakeService
  ){
    this.addVehicleMakeForm = this.formBuilder.group({
      name: ['', [ Validators.required]],
    });
  }
  saveVehicleMake(){
    console.log(this.addVehicleMakeForm.value);
    this.masterMakeService.saveVehicleMake(this.addVehicleMakeForm.value).subscribe((res:any) => {
      this.responseMsg = res.message
    })
  }
}
